const appEnv = process.env.REACT_APP_ENV || "local";

interface Environment {
  apiUrl: string;
}

interface Environments {
  [key: string]: Environment;
}

const environments: Environments = {
  local: {
    apiUrl: process.env.REACT_APP_API || "http://0.0.0.0:3000",
  },
  development: {
    apiUrl: process.env.REACT_APP_API || "https://in-dev.api.traffic.mergex.dev",
  },
  staging: {
    apiUrl: process.env.REACT_APP_API || "https://traffic.mergex.dev",
  },
  production: {
    apiUrl: process.env.REACT_APP_API as string,
  },
};

export const appEnvironment: Environment = environments[appEnv];
